function IsWebAuthnSupported() {
  if (!window.PublicKeyCredential) {
    console.log('Web Authentication API is not supported on this browser.');
    return false;
  }

  return true;
}

function isWebAuthnPlatformAuthenticatorAvailable() {
  let theElement = document.getElementById('biometrics-div');
  if (theElement) theElement.style.display = 'none';

  theElement = document.getElementById('windowshello-div');
  if (theElement) theElement.style.display = 'none';

  theElement = document.getElementById('faceid-div');
  if (theElement) theElement.style.display = 'none';

  theElement = document.getElementById('touchid-div');
  if (theElement) theElement.style.display = 'none';

  // skip the WebAuthn support check on Internet Explorer as both WebAuthn and Promise are not supported on IE
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  // eslint-disable-next-line
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return false;
  }

  let timer;

  const p1 = new Promise((resolve) => {
    timer = setTimeout(() => {
      console.log('isWebAuthnPlatformAuthenticatorAvailable - Timeout');
      resolve(false);
    }, 300);
  });

  const p2 = new Promise((resolve) => {
    if (
      IsWebAuthnSupported() &&
      window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable
    ) {
      resolve(
        window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().catch(
          (err) => {
            console.log(err);
            return false;
          }
        )
      );
    } else {
      resolve(false);
    }
  });

  return Promise.race([p1, p2]).then((res) => {
    clearTimeout(timer);
    console.log(`isWebAuthnPlatformAuthenticatorAvailable - ${res}`);

    if (res) {
      theElement = document.getElementById('biometrics-div');
      if (theElement) theElement.style.display = 'block';

      theElement = document.getElementById('windowshello-div');
      if (theElement) theElement.style.display = 'block';

      theElement = document.getElementById('faceid-div');
      if (theElement) theElement.style.display = 'block';

      theElement = document.getElementById('touchid-div');
      if (theElement) theElement.style.display = 'block';
    }

    return res;
  });
}

const localWindow = window || {};
localWindow.aib = localWindow.aib || {};
const { aib } = localWindow;
aib.shared = {
  ...aib.shared,
  isWebAuthnPlatformAuthenticatorAvailable,
};
